class Animation {
    constructor() {
        this.orange = document.querySelector('.jackpot.orange');
        this.blue = document.querySelector('.jackpot.blue');
        this.purple = document.querySelector('.jackpot.purple');
        this.scheme = ['orange', 'purple', 'blue'];
        this.schemeIndex = 0;
        this.interval = null;

        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.change = this.change.bind(this);
    }

    change() {
        this.schemeIndex++;
        if(typeof this.scheme[this.schemeIndex] === 'undefined')
            this.schemeIndex = 0;

        const current_color = document.querySelector(`.jackpot.${this.scheme[this.schemeIndex]}`),
              active_color = document.querySelector('.jackpot.active');

        current_color.style.zIndex = 1;
        active_color.style.zIndex = 0;

        current_color.style.opacity = 1;
        current_color.classList.add('active');

        setTimeout(() => {
            active_color.classList.remove('active');

            const jackpots = document.querySelectorAll('.jackpot');

            for(let i = 0; i < jackpots.length; i++)
                if(!jackpots[i].classList.contains(this.scheme[this.schemeIndex])) {
                    jackpots[i].style.zIndex = 0;
                    jackpots[i].style.opacity = 0;
                }
        }, 1e3);
    }

    start() {
        this.interval = setInterval(this.change, 10e3);
    }

    stop() {
        clearInterval(this.interval);
    }
}

export default new Animation();